import React from 'react';
import ThemeSwitcher from './ThemeSwitcher';

const Header = ({ title, subtitle }) => {
  const userData = localStorage.getItem('user');
  const user = userData ? JSON.parse(userData) : null;
  const initial = user?.name ? user.name.charAt(0).toUpperCase() : 'U';

  return (
    <header className="app-header">
      <div className="header-title-group">
        <h1>{title}</h1>
        {subtitle && <p>{subtitle}</p>}
      </div>

      <div className="header-controls">
        <ThemeSwitcher />

        <div className="user-profile-badge">
          <div className="user-avatar">{initial}</div>
          <div className="user-info-text">
            <span className="user-name">{user?.name || 'User'}</span>
            <span className="user-role">{user?.role || 'Student'}</span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;